
import './App.css';
import Search from './Components/Search';


function App() {

  return (
    <div className="App">
      <Search />

    </div>
  );
}

export default App;
